import React, { useState } from "react";
import { SectionHeader } from "@/components/shared/Common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CONTACT } from "@/constants/testIds";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const enquiryTypes = [
  "I need security staff",
  "I want to register as staff",
  "I am a security company",
  "Other",
];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", message: "", enquiry_type: enquiryTypes[0] });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success("Message sent. We'll be in touch shortly.");
      setForm({ name: "", email: "", phone: "", company: "", message: "", enquiry_type: enquiryTypes[0] });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <SectionHeader
        eyebrow="Contact"
        title="Talk to the SecuSource team."
        subtitle="Send us a message and we'll get back to you shortly."
      />
      <form onSubmit={submit} className="card-flat p-6 space-y-4" data-testid={CONTACT.form}>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label className="font-manrope">Name</Label>
            <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
          </div>
          <div>
            <Label className="font-manrope">Email</Label>
            <Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
          </div>
          <div>
            <Label className="font-manrope">Phone</Label>
            <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" />
          </div>
          <div>
            <Label className="font-manrope">Company (optional)</Label>
            <Input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} data-testid="contact-company" />
          </div>
        </div>

        <div>
          <Label className="font-manrope">Enquiry type</Label>
          <Select value={form.enquiry_type} onValueChange={(v) => setForm({ ...form, enquiry_type: v })}>
            <SelectTrigger data-testid="contact-enquiry-type"><SelectValue /></SelectTrigger>
            <SelectContent>
              {enquiryTypes.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label className="font-manrope">Message</Label>
          <Textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
        </div>

        <Button type="submit" disabled={busy} className="bg-brand hover:bg-brand-hover text-white w-full py-6 font-manrope font-semibold" data-testid={CONTACT.submit}>
          {busy ? "Sending…" : sent ? "Sent" : "Send Message"}
        </Button>
      </form>
    </div>
  );
}
